// extracted by mini-css-extract-plugin
export var equalColumn = "_gm-0";